<template>
    <div class="page-content-container">
        <div class="page-content-header">
            <div class="page-header-block"></div>
            <div class="page-content-header-item">
                我的权益
            </div>
        </div>
        <div class="page-content-wrapper">
            <div class="page-content">
                <div class="page-content-item-wrapper">
                    <div class="page-content-item" @click="viewDetail('record-learn')">
                        <div class="page-content-img-wrapper" style="background: #929AF1;">
                            <img src="@/assets/img/r2.png" alt="" class="page-content-img">
                        </div>
                        <div class="page-content-label">点播</div>
                    </div>
                </div>
                <div class="page-content-item-wrapper">
                    <div class="page-content-item" @click="viewDetail('live-learn')">
                        <div class="page-content-img-wrapper" style="background: #3E63EE;">
                            <img src="@/assets/img/r1.png" alt="" class="page-content-img">
                        </div>
                        <div class="page-content-label">直播</div>
                    </div>
                </div>

                <!-- <div class="page-content-item-wrapper">
                    <div class="page-content-item" @click="viewDetail('offline-courses')">
                        <div class="page-content-img-wrapper" style="background: #6699FF;">
                            <img src="@/assets/img/r3.png" alt="" class="page-content-img">
                        </div>
                        <div class="page-content-label">线下公开课</div>
                    </div>
                </div>
                <div class="page-content-item-wrapper" style="margin-right:0;">
                    <div class="page-content-item" @click="viewDetail('test-practice')">
                        <div class="page-content-img-wrapper" style="background: #FEB700;">
                            <img src="@/assets/img/r4.png" alt="" class="page-content-img">
                        </div>
                        <div class="page-content-label">试题练习</div>
                    </div>
                </div> -->
                <div class="page-content-item-wrapper">
                    <div class="page-content-item" @click="viewDetail('study-plan')">
                        <div class="page-content-img-wrapper" style="background: #FF9645;">
                            <img src="@/assets/img/r5.png" alt="" class="page-content-img">
                        </div>
                        <div class="page-content-label">学习计划</div>
                    </div>
                </div>
                <!-- <div class="page-content-item-wrapper">
                    <div class="page-content-item" @click="viewDetail('test-simulation')">
                        <div class="page-content-img-wrapper" style="background: #19BA51;">
                            <img src="@/assets/img/r6.png" alt="" class="page-content-img">
                        </div>
                        <div class="page-content-label">考试</div>
                    </div>
                </div>
                <div class="page-content-item-wrapper">
                    <div class="page-content-item" @click="viewDetail('experts-answer')">
                        <div class="page-content-img-wrapper" style="background: #248DE8;">
                            <img src="@/assets/img/r7.png" alt="" class="page-content-img">
                        </div>
                        <div class="page-content-label">专家答疑</div>
                    </div>
                </div> -->
                <!-- 专家答疑 -->
                <div class="page-content-item-wrapper">
                    <div class="page-content-item" @click="localView">
                        <div class="page-content-img-wrapper" style="background: #19BA51;">
                            <img src="@/assets/img/r7.png" alt="" class="page-content-img">
                        </div>
                        <div class="page-content-label">专家答疑</div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    props: {
        deptVal: String,
        tokenVal: String
    },
    components: {

    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        viewDetail(target) {
            if (target == 'study-plan') {
                this.$router.push(`/studyPlan/manage-plan`);
            } else {
                this.$router.push(`/myRights/${target}`);
            }
        },
        localView() {
            this.$router.push('/questing')
        }
    }
}
</script>
<style scoped>
.page-content-container {
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
}

.page-content-header {
    width: 100%;
    height: 100px;
    border-radius: 6px 5px 0px 0px;
    line-height: 80px;
    position: relative;
    display: flex;
}

.page-header-block {
    width: 6px;
    height: 24px;
    background: #4F79ED;
    border-radius: 0px 17px 17px 0px;
    position: absolute;
    left: 0px;
    top: 28px;
}

.page-content-header-item {
    width: 170px;
    height: 100%;
    text-align: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3E63EE;
}

.page-content-wrapper {
    display: flex;
}

.page-content {
    flex: 1;
    margin: 30px 41px 30px 45px;
    display: flex;
    /* flex-wrap: wrap; */
}

.page-content-item-wrapper {
    width: 23.5%;
    height: 103px;
    margin-right: 2%;
    margin-bottom: 42px;
    display: flex;
}

.page-content-item {
    flex: 1;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #D8D8EA;
    display: flex;
    align-items: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.page-content-item:hover {
    cursor: pointer;
    box-shadow: 2px 2px 14px 0px rgba(156, 159, 167, 0.28);
}

.page-content-img-wrapper {
    width: 58px;
    height: 58px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 20px;
    margin-right: 20px;
}

.page-content-img {
    width: 30px;
}

.page-content-label {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
}
</style>

